import styled from 'styled-components';

const StyledQueryEntityDrag = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${props => props.theme.spacing.medium};
  cursor: ${props => (!props.isDragging ? 'grab' : 'grabbing')};
`;

const StyledQueryEntityActions = styled.div`
  display: flex;
  align-items: center;
`;

const StyledQueryEntityContent = styled.div`
  flex: 1;
  padding-right: 30px;

  input {
    min-height: ${props => props.theme.spacing.large};
  }

  button i svg {
    display: none;
  }
`;

export {
  StyledQueryEntityDrag,
  StyledQueryEntityActions,
  StyledQueryEntityContent,
};
